export enum DuePaymentStatus {
  SUBMITTED = 'SUBMITTED',
  VALIDATED = 'VALIDATED',
  CANCELLED = 'CANCELLED'
}
